import { Controller } from '@hotwired/stimulus'
import {
  formatNumberInput, parseNumberInput, skipNumberSeparator
} from '../utilities'

export default class extends Controller {
  static targets = ['wages', 'contractors', 'savings']

  connect() {
    this.calculate()
  }

  calculate() {
    const wages = parseNumberInput(this.wagesTarget.value)
    const contractors = parseNumberInput(this.contractorsTarget.value) * 0.65
    const savings = (wages + contractors) * 0.1
    this.savingsTarget.textContent = this.#formatValue(savings)
  }

  format(event) {
    formatNumberInput(event.target)
    this.calculate()
  }

  skipSeparator(event) {
    skipNumberSeparator(event)
  }

  #formatValue(value) {
    const decimals = value % 1 === 0 ? 0 : 2
    const formatted = value.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    })
    return `$${formatted}`
  }
}
